<template>
    <div>
        <div class="product-label-line">
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">图层时相：</div><div class="product-label-data">{{$store.state.deliveryDetail.productTime}}</div>
            </div>
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">切片层级：</div><div class="product-label-data">{{$store.state.deliveryDetail.level}}</div>
            </div>
        </div>
        <div class="product-label-line">
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">数据格式：</div><div class="product-label-data">{{$store.state.deliveryDetail.format}}</div>
            </div>
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">覆盖面积：</div><div class="product-label-data">{{$store.state.deliveryDetail.area}}km<sup>2</sup></div>
            </div>
        </div>
        <div class="product-label-line">
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">发布时间：</div><div class="product-label-data">{{$store.state.deliveryDetail.gmtCreated}}</div>
            </div>
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">数据大小：</div><div class="product-label-data">{{$store.state.deliveryDetail.zipSize}}</div>
            </div>
        </div>
        <div class="product-label-line">
            <div style="width: 50%;display: flex;">
                <div class="product-label-title">快捷操作：</div>
                <div style="font-size: 12px;color: #508CDD;cursor: pointer;" @click="copyJson">导出接口文件</div>
            </div>
        </div>
        <div class="code-panel">
            <codemirror ref="myCm" :value="resArr" :options="cmOptions"></codemirror>
        </div>
    </div>
</template>
<script>
    import { codemirror } from 'vue-codemirror';
    import 'codemirror/lib/codemirror.css';
    import 'codemirror/theme/darcula.css';
    
    export default {
        name: "TileDetail",
        data() {
            return {
                cmOptions:{
                    value:'',
                    mode:'application/json',  //模式
                    theme:'darcula',          //主题
                    indentUnit:2,
                    smartIndent:true,
                    tabSize:4,
                    readOnly:true,    //只读
                    showCursorWhenSelecting:true,
                    lineNumbers:true, //是否显示行数
                    firstLineNumber:1
                },
            }
        },
        components: {
            codemirror
        },
        computed: {
            resArr: function () {
                if (!this.$store.state.deliveryDetail.hasOwnProperty("dataType") || this.$store.state.deliveryDetail.dataType === 2) {
                    return JSON.stringify({
                        "name": this.$store.state.deliveryDetail.productName,
                        "serviceInfo": "https://manage.charmingglobe.com/highmanage/seniorProductMgr/getProductServiceDetailById?productId=" +
                            this.$store.state.deliveryDetail.productId,
                        "url": this.$store.state.deliveryDetail.serviceUrl,
                        "legend": JSON.parse(this.$store.state.deliveryDetail.properties).legentUrl,
                        "styleStr": JSON.parse(this.$store.state.deliveryDetail.styleStr),
                        "geoJson":JSON.parse(this.$store.state.deliveryDetail.geo)
                    }, null, 2)
                } else {
                    return "";
                }
            },
        },
        mounted() {
        
        },
        methods: {
            copyJson(){
                let blob = new Blob([(this.resArr)], {type: "application/json;charset=utf-8"});
                saveAs(blob, this.$store.state.deliveryDetail.productId+'.json',)
            },
        }
    }
</script>
<style scoped>
    .product-label-line {
        display: flex;
        width: 100%;
        margin: 8px;
    }
    .product-label-title {
        color: #818181;
        font-size: 12px;
    }
    .product-label-data {
        color: #101010;
        font-size: 12px;
    }
    .code-panel {
        width: 700px;
        height: 630px;
        font-size: 12px;
        margin-bottom: 30px;
    }
</style>